import { AfterViewInit, Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from "@angular/core";
import { FormArray, FormBuilder, FormGroup, Validators } from "@angular/forms";
import { ToastrService } from "ngx-toastr";
import { EnumStoredService, ENUM } from "src/app/core/services/enum.service";
import {
    Constant,
    RequireTypeFile
} from "src/app/core/helper/validator-custom/ValidatorCustom";
import { environment } from "src/environments/environment";
import { URL_IMAGE_PREV } from "src/app/core/common/constant";
import {BsModalRef} from 'ngx-bootstrap/modal';
import {DatePipe} from '@angular/common';
import {TranslateService} from '@ngx-translate/core';
import {ToastrMessageService} from '../../../../core/services/toastr.message.service';
import {CatalogItemService} from '../../../../core/services/catalog.item.service';
import {CatalogItemModel} from '../../../../core/models/catalog.item.model';
import {CatalogItemAddModel} from '../../../../core/models/catalog.item.add.model';
import {FormlyFieldConfig} from '@ngx-formly/core';
import {EmployeeService} from '../../../../core';
declare const $: any;

@Component({
    selector: "app-add-storage-profile-modal",
    templateUrl: "./add-storage-profile-modal.component.html",
    styleUrls: ["./add-storage-profile-modal.component.css"],
})
export class AddStorageProfileModalComponent {
    employee
    constructor(
        public bsModalRef: BsModalRef,
        private datePipe: DatePipe,
        private translate: TranslateService,
        public toastrMessage: ToastrMessageService,
        public catalogItemService: CatalogItemService,
        private employeeService: EmployeeService,
        private toastr: ToastrService
    ) {
    }

    @Output() addOtherItemIdSuccess = new EventEmitter<boolean>();

    addOtherItemModel: any = {};

    cancelCatalogItemOtherAdd() {
        this.bsModalRef.hide();
    }

    saveCatalogItemOther() {
        this.addOtherItemForm.markAllAsTouched();
        if (this.addOtherItemForm.invalid) {
            return;
        }

        let catalogItemAddModel: CatalogItemAddModel = new CatalogItemAddModel();
        catalogItemAddModel.name = this.addOtherItemModel.itemOther;
        const formData = new FormData();
        formData.append("employeeId", this.employee.id)
        formData.append("employeeCode", this.employee.employeeCode)
        formData.append("listCatalogStoredName", this.addOtherItemModel.itemOther);
        this.employeeService.updateCategoryStored(formData).subscribe({next: result => {
            if (result && result.success) {
                this.toastr.success("Thêm mới hồ sơ thành công");
                this.closeModal();
                this.addOtherItemIdSuccess.emit(this.addOtherItemModel.itemOther);
            } else if(result.success == false) {
                this.toastr.error(result.message);
            }
        }, error: error => {
            this.toastr.error('', error.error.message);
        }})
    }

    itemOtherField: FormlyFieldConfig = {
        key: 'itemOther',
        type: 'input',
        className: 'col-12',
        templateOptions: {
            label: "Tên danh mục",
            required: true,
            maxLength: 255
        }
    }

    addOtherItemFields: FormlyFieldConfig[] = [
        {
            fieldGroupClassName: 'row',
            fieldGroup: [
                this.itemOtherField
            ]
        }
    ];
    addOtherItemForm: FormGroup = new FormGroup({});

    closeModal() {
        this.bsModalRef.hide();
    }
}
